import Visibility from '../../assets/images/visibility.png'
import VisibilityOff from '../../assets/images/visibilityOff.png'
import { InputAdornment, TextField, Box } from '@mui/material'
import { useState } from 'react'
import { IPasswordInput } from './types'
import LabelErrorTAG from '../LabelErrorTAG'

const PasswordInput: React.FC<IPasswordInput> = props => {
  const { fieldName, label, register, error = '' } = props
  const [showPassword, setShowPassword] = useState<boolean>(false)

  const handleClick = () => {
    setShowPassword(!showPassword)
  }

  return (
    <Box sx={{ width: '100%' }}>
      <LabelErrorTAG label={label} error={error} />
      <TextField
        {...register(fieldName)}
        variant='standard'
        type={showPassword ? 'text' : 'password'}
        fullWidth
        InputProps={{
          endAdornment: (
            <InputAdornment position='end'>
              <img
                src={showPassword ? Visibility : VisibilityOff}
                aria-label='toggle password visibility'
                onClick={handleClick}
                style={{
                  position: 'absolute',
                  right: '8px',
                  top: `${showPassword ? '16px' : '13px'}`,
                  width: '21px',
                  height: `${showPassword ? '15px' : '21px'}`,
                }}
              ></img>
            </InputAdornment>
          ),
        }}
      />
    </Box>
  )
}

export default PasswordInput
